import { useState } from "react";
import { Modal, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ClientsService } from "../pages/private/modules/dashboard/services/featurejobclients.service";
import { useProfile } from "../pages/private/modules/profile/components/ProfileContext";
import { route } from "../constants/routes";

export const useAddJobValidation = () => {
  const { profile } = useProfile();
  const companyId = profile?.companyId;
  const [checking, setChecking] = useState(false);
  const navigate = useNavigate();

  const handleAddJob = async () => {
    if (checking) return;

    if (!companyId) {
      message.error("Company ID not found.");
      return;
    }

    setChecking(true);
    try {
      const res = await ClientsService.GetAll(companyId, { page: 1, size: 1 });

      if (!res || !res.content || res.content.length === 0) {
        Modal.confirm({
          title: "You need a client to create a Job",
          content: "Please create a client first before adding a Job.",
          okText: "Go to Clients",
          cancelText: "Cancel",
          onOk: () => navigate(route("/company/clients")),
        });
        return;
      }

      navigate(route("/job/create"));
    } catch (err) {
      message.error("Failed to validate clients. Please try again.");
    } finally {
      setChecking(false);
    }
  };

  return { handleAddJob, checking };
};
